import { BaseTable, NumberInput } from "components"
import { useFormContext, useWatch,Controller } from "react-hook-form"
import { FormInvoiceType } from "../types"
import { calculateSummaryInvoice } from "../utils/functions"

export const SummaryFooter = () => {
  const { control,getValues } = useFormContext<FormInvoiceType>()
  const [freight, invoice_detail, total_payment] = useWatch({
    control,
    name: ["freight", "invoice_detail", "total_payment"]
  })
  const summary = calculateSummaryInvoice({
    invoice_detail,
    freight,
    total_payment
  })

  return (
    <section className="flex flex-col lg:items-end gap-3">
      <BaseTable
        plain
        className="w-full min-w-[100px] md:max-w-[400px] text-right"
      >
        <tbody>
          <tr>
            <td className="w-[1px] whitespace-nowrap">SUBTOTAL</td>
            <td>{summary?.subtotal?.toLocaleString()}</td>
          </tr>
          <tr>
            <td className="w-[1px] whitespace-nowrap">FREIGHT</td>
            <Controller
                control={control}
                name="freight"
                render={({ field, fieldState }) => (
                  <NumberInput
                    textRight
                    value={field.value}
                    disabled={Boolean(getValues('approval_status') === 4)}
                    ref={field.ref}
                    onValueChange={(value) => field.onChange(value.floatValue)}
                    error={fieldState.error?.message}
                  />
                )}
              />
          </tr>
          <tr>
            <td className="w-[1px] whitespace-nowrap">TAX</td>
            <td>{summary?.tax?.toLocaleString()}</td>
          </tr>
          <tr className="font-bold">
            <td className="w-[1px] whitespace-nowrap">TOTAL AMOUNT</td>
            <td>{summary?.totalAmount?.toLocaleString()}</td>
          </tr>
          <tr className="text-error">
            <td className="w-[1px] whitespace-nowrap">PAYMENT</td>
            <td>{summary?.payment?.toLocaleString()}</td>
          </tr>
          <tr className="border-y-2 border-black text-lg font-bold">
            <td className="w-[1px] whitespace-nowrap">BALANCE</td>
            <td>{summary?.balance?.toLocaleString()}</td>
          </tr>
        </tbody>
      </BaseTable>
    </section>
  )
}
